import { render } from "./dol-icon-select.vue?vue&type=template&id=85f3760a"
import script from "./dol-icon-select.vue?vue&type=script&lang=js"
export * from "./dol-icon-select.vue?vue&type=script&lang=js"

import "./dol-icon-select.vue?vue&type=style&index=0&id=85f3760a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__